export default __webpack_public_path__ + "static/media/Logo_210430_2.ea7dbd77.png";